<template>
  <div class="party-chances">
    <span
      class="party-chances__party"
      :style="`color: ${gopColor};`">
      REPUBLICANS
      <br/>
      <span class="party-chances__party--chance">{{ formattedRepublicanChance }}</span>
    </span>

    <span>
      <span class="formatted-date">{{ electionDate | date }}</span>
      <br/>
      Days to Election: <span class="days-to-election">{{ daysToElection }}</span>
    </span>

    <span
      class="party-chances__party"
      :style="`color: ${demColor};`">
      DEMOCRATS
      <br/>
      <span class="party-chances__party--chance">{{ formattedDemocratChance }}</span>
    </span>
  </div>
</template>

<script>
const props = {
  electionDate: {
    default: "2022-06-22",
    required: true,
    type: String,
  },
  isContested: {
    default: true,
    required: true,
    type: Boolean,
  },
  republicanChanceOfWinning: {
    default: 0,
    required: true,
    type: Number,
  },
  democratChanceOfWinning: {
    default: 0,
    required: true,
    type: Number,
  },
};

const computed = {
  daysToElection() {
    const dateParts = this.electionDate.split("-");
    const year = parseInt(dateParts[0]);
    const monthIndex = parseInt(dateParts[1]) - 1; // curse you Brendan Eich
    const day = parseInt(dateParts[2]);

    const electionDate = new Date(year, monthIndex, day, 0, 0, 0, 0);
    const currentDate = new Date().setHours(0, 0, 0, 0);

    if (currentDate >= electionDate.valueOf()) return 0;

    const oneDay = 24 * 60 * 60 * 1000; // hours * minutes * seconds * milliseconds
    const difference = Math.floor((electionDate - currentDate) / oneDay);

    const daysRemaining = difference > 0 ? difference : 0;
    return daysRemaining;
  },
  formattedRepublicanChance() {
    if (this.isContested) {
      if (this.republicanChanceOfWinning >= 99) return "> 99.0%";
      if (this.republicanChanceOfWinning < 1) return "< 1.0%";
    } else {
      if (this.republicanChanceOfWinning >= 99) return "100.0%";
      if (this.republicanChanceOfWinning <= 1) return "0.0%";
    }

    const chance = this.republicanChanceOfWinning.toFixed(1).toString();
    return `${chance}%`;
  },
  formattedDemocratChance() {
    if (this.isContested) {
      if (this.democratChanceOfWinning >= 99) return "> 99.0%";
      if (this.democratChanceOfWinning <= 1) return "< 1.0%";
    } else {
      if (this.democratChanceOfWinning >= 99) return "100.0%";
      if (this.democratChanceOfWinning <= 1) return "0.0%";
    }

    const chance = this.democratChanceOfWinning.toFixed(1).toString();
    return `${chance}%`;
  },
};

export default {
  props,
  computed,
  data: () => ({
    gopColor: "#d84b44",
    demColor: "#4575a1",
  }),
};
</script>

<style>
.party-chances {
  align-items: center;
  display: flex;
  gap: 1em;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 30em;
  text-align: center;
}

.party-chances__party {
  font-size: .85rem;
  font-weight: 500;
}

.party-chances__party--chance {
  font-size: 2rem;
  font-weight: 700;
}

.formatted-date {
  font-size: 1.25rem;
  font-weight: bold;
}

.days-to-election {
  color: #57aea6;
}
</style>
